/**
 *
 * Collaborators
 *
 */

import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Input, Radio, Select, Checkbox, Button, Tooltip, Dropdown, Menu, Popover } from "antd"
import { DownOutlined, CloseOutlined, SearchOutlined, PlusOutlined, UploadOutlined, DownloadOutlined, AntDesignOutlined, UserAddOutlined } from "@ant-design/icons"
import { pick, debounce } from "lodash"
import Loader from "components/Loader"
import FiltersContainer from "components/FiltersContainer"
import deleteSvg from "../../images/delete.svg"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import EmptyButton from "components/EmptyButton"
import ImportScreen from "components/ImportScreen"
import CollaboratorsTable from "components/CollaboratorsTable"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import reducer from "./reducer"
import saga from "./saga"

import {
  makeSelectHasDivisions,
  makeSelectIsDownloading,
  makeSelectIsUploading,
  makeSelectGetCollaborators,
  makeSelectIsLoadingCollaboratorsTable,
  makeSelectHasCollaborators,
  makeSelectCollaboratorTeam,
  makeSelectIsLoadingCollaboratorTeam,
  makeSelectPotentialLeaders,
  makeSelectTeamPotential,
  makeSelectIsLoadingTeamPotential,
  makeSelectIsLoadingPotentialLeaders,
  makeSelectIsLoadingMeasures,
  makeSelectMeasuresAffected,
  makeSelectHasSegments,
  makeSelectVismaPeopleStatus,
  makeSelectIsLoadingVismaPeopleStatus,
} from "./selectors"

import {
  getTemplateCollaboratorsWatcher,
  uploadTemplateCollaboratorsWatcher,
  getCollaboratorsWatcher,
  searchCollaboratorsWatcher,
  hasDivisionsWatcher,
  hasCollaboratorsWatcher,
  getTeamWatcher,
  getPotentialLeadersWatcher,
  assignLeaderWatcher,
  getTeamPotentialWatcher,
  addEmployeesTeamWatcher,
  removeEmployeesTeamWatcher,
  removeCollaboratorsWatcher,
  getMeasuresWatcher,
  getVismaPeopleStatusWatcher,
} from "./actions"

import collaboratorsSvg from "../../images/collaborators.svg"
import leftArrowSvg from "../../images/left-arrow.svg"
import "./index.less"
import {
  visitPageSegment,
  PAGE_ORGANIZATION_COLLABORATOR,
} from "../../utils/segment/segmentTracks"
import {
  isModuleBySlug,
  KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
  LOCAL_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER,
  LOCAL_ORGANIZATION_COLLABORATORS_TEXT_FILTER,
  LOCAL_VISMA_PEOPLE_SYNC_ENABLED,
  setItem,
} from "../../utils/storage"
import {
  AMBASSADOR_USERS,
  COLUMN_LIST_COLLABORATORS,
  SEGMENTS,
} from "../../utils/constants"
import { Link, withRouter } from "react-router-dom"

const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const CheckboxGroup = Checkbox.Group
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class Collaborators extends Component {
  state = {
    columnsSelected: JSON.parse(
      LOCAL_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER()
    ),
    inputSearch: LOCAL_ORGANIZATION_COLLABORATORS_TEXT_FILTER(),
    isLoadingTable: false,
    openColumnSelect: false,
    filtersDropdown: [],
    filtersDeleted: undefined,
    isFirstTime: true,
    tagFilters: [],
    removeFilterCallback: null,
    activeFilters: { divisions: [], segments: [], leaders: [] },
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.collaborators.employees_without_division_visma_people && nextProps.collaborators.employees_without_division_visma_people > 0) {
      this.props.onCollaboratorsWithoutDivisionChange(nextProps.collaborators.employees_without_division_visma_people)
    }
  }

  UNSAFE_componentWillMount = () => {
    document.addEventListener(
      "click",
      (e) => {
        if (
          this.state.openColumnSelect &&
          this.wrapperRefCheckbox &&
          !this.wrapperRefCheckbox.contains(e.target) &&
          e.target &&
          !e.target.closest(".ant-select-dropdown")
        ) {
          this.setState({ openColumnSelect: false })
        }
      },
      false
    )
  }
  
  componentDidMount = () => {
    if (this.state.inputSearch != "") {
      this.searchCollaboratorsDebounce(this.state.inputSearch)
    } else {
      let payload ={
        page: 1,
        perPage: 15,
      }
    this.props.getCollaboratorsWatcher(payload)
    }
    this.props.hasDivisionsWatcher()
    this.props.hasCollaboratorsWatcher()

    visitPageSegment(PAGE_ORGANIZATION_COLLABORATOR)
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.isFirstTime && Array.isArray(this.props.collaborators.data)) {
      if (this.state.isFirstTime) {
        this.setState({ isFirstTime: false });
      }
    }
  }
  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplateCollaborators(fd)
    this.fileInput.value = ""
  }

  clickCheckboxs = (e) => {
    setItem(KEY_ORGANIZATION_COLLABORATORS_COLUMNS_FILTER, JSON.stringify(e))
    this.setState({ columnsSelected: e })
  }

  handleActiveFiltersChange = (filters) => {
    this.setState({ activeFilters: filters })
  }

  searchCollaborators = (value) => {
    if (typeof value !== 'string') {
      this.props.searchCollaboratorsWatcher(value)
      this.setState({ isLoadingTable: false })
      return
    }

    const { activeFilters } = this.state
    const hasFilters =
      activeFilters.divisions.length > 0 ||
      activeFilters.segments.length > 0 ||
      activeFilters.leaders.length > 0

    if (hasFilters) {
      this.props.searchCollaboratorsWatcher({
        current: 1,
        pageSize: 15,
        sortField: '',
        sortOrder: '',
        leaders: activeFilters.leaders,
        divisions: activeFilters.divisions,
        segments: activeFilters.segments,
        searchText: value,
      })
    } else {
      this.props.searchCollaboratorsWatcher(value)
    }
    this.setState({ isLoadingTable: false })
  }

  getCollaboratorsPaginated = (page, pageSize,sortField,sortOrder) =>{
    let payload ={
      page :page,
      perPage:pageSize,
      sortField : sortField,
      sortOrder : sortOrder
    }
    
   
    if (this.state.inputSearch && this.state.inputSearch.trim() !== '') {
      payload.searchByDivisionName = this.state.inputSearch.trim()
    }
    
    this.props.getCollaboratorsWatcher(payload)
  }

  onFiltersChange = (filters, removeFilterCallback) => {
    this.setState({ 
      tagFilters: filters, 
      removeFilterCallback: removeFilterCallback 
    })
  }

  removeFilter = (itemRemoved) => {
    if (this.state.removeFilterCallback) {
      return this.state.removeFilterCallback(itemRemoved)
    }
    return Promise.resolve()
  }

  renderOptionsSelectColumn = () => {
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    const isSegment = isModuleBySlug(SEGMENTS)
    return COLUMN_LIST_COLLABORATORS.map((row) => {
      if (row.value === "embajador" && !isAmbassador) {
        return null
      }
      if (row.value === "segment" && !isSegment) {
        return null
      }
      if (row.value === "segment" && isSegment && !this.props.hasSegments) {
        return null
      }
      return (
        <Option
          key={`option-${row.value}`}
          value={row.value}
          name={row.description}>
          <Checkbox key={`checkbox-${row.value}`} value={row.value}>
            {row.description}
          </Checkbox>
        </Option>
      )
    })
  }

  renderFilterColumns = () => {
    const { openColumnSelect } = this.state
    return (
      <div
        ref={(ele) => {
          this.wrapperRefCheckbox = ele
        }}>
        <CheckboxGroup
          value={this.state.columnsSelected}
          onChange={this.clickCheckboxs}
          style={{ position: "relative"}}>
          <DownOutlined
            className="arrow-down-select"
            onClick={() =>
              this.setState({
                openColumnSelect: !openColumnSelect,
              })
            }
          />
          <Select
            value={[]}
            onFocus={() => this.setState({ openColumnSelect: true })}
            onBlur={() => this.setState({ openColumnSelect: false })}
            open={openColumnSelect}
            mode="multiple"
            listHeight={1000}
            dropdownStyle={{ maxHeight: '400px' }}
            style={{ width: 160 }}
            placeholder="Columnas">
            {this.renderOptionsSelectColumn()}
          </Select>
        </CheckboxGroup>
      </div>
    )
  }

  searchCollaboratorPaginated = (data) => {
   
    if (this.state.inputSearch && this.state.inputSearch.trim() !== '') {
      data.searchText = this.state.inputSearch.trim();
    }
    
    this.searchCollaboratorsDebounce(data)
    this.setState({
      isLoadingTable: true,
    })
  }

  renderFilterSearch = () => {
    const { inputSearch } = this.state
    return (
      <Input
        value={inputSearch}
        onChange={(e) => {
          localStorage.setItem(
            "organization_collaborators_text_filter",
            e.target.value
          )
          this.searchCollaboratorsDebounce(e.target.value)
          this.setState({
            inputSearch: e.target.value,
            isLoadingTable: true,
          })
        }}
        className="collaborators-header-search"
        placeholder="Buscar..."
        suffix={
          inputSearch ? (
            <CloseOutlined
              onClick={() => {
                localStorage.setItem(
                  "organization_collaborators_text_filter",
                  ""
                )
                this.setState({ inputSearch: "" })
                this.props.searchCollaboratorsWatcher("")
              }}
              className="collaborators-header-search-clear"
            />
          ) : (
            <SearchOutlined style={{ color: '#A7A3A3' }} />
          )
        }
      />
    )
  }

  renderVismaPeopleEmptyState = () => {
    return (
      <div className="collaborators-has-divisions">
        <img alt="collaborators-svg" src={collaboratorsSvg} />
        <h2 style={{fontSize: 16, marginBottom: 24}}>Agregar colaboradores</h2>
        <p>
          Carga la información de tus colaboradores en <b>Visma People</b>. Luego, en Clima y Engagement, <br />
          estos podrán convertirse en usuarios desde la sección <b>Panel de Control - Gestión de Usuarios</b>.
        </p>
        <Button
          className="collaborators-has-divisions-button">
          <img src={leftArrowSvg} />
          <a href="https://people.vismalatam.com" target="_blank">Ir a Visma People</a>
        </Button>
      </div>
    )
  }

  renderEmptyDivisions = () => {
    if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
      return this.renderVismaPeopleEmptyState()
    }

    return (
      <div className="collaborators-has-divisions">
        <img alt="collaborators-svg" src={collaboratorsSvg} />
        <p>
          No es posible cargar colaboradores sin haber importado primero las
          divisiones.
        </p>
        <Button
          onClick={() => this.props.changeTab("divisions")}
          className="collaborators-has-divisions-button">
          <img src={leftArrowSvg} />
          Ir a Divisiones
        </Button>
      </div>
    )
  }

  renderButtonAddEmployee = () => {
    const countEmployees = this.props.collaborators.length
    const freemium = window.freemium()
    if (freemium && freemium.maxEmployees <= countEmployees) {
      return (
        <Popover
          content={
            <div style={{ maxWidth: 220 }}>
              <p>
                La cantidad de colaboradores ha alcanzado el máximo disponible.
              </p>
              <span className="color-gray-low" style={{ fontSize: 12 }}>
                Máximo: {freemium.maxEmployees} colaboradores
              </span>
            </div>
          }
          placement="bottomLeft">
          <Button
            className="blueButton"
            disabled
            size="default"
            type="primary"
            icon={<PlusOutlined />}
          />
        </Popover>
      )
    }
    return (
      <Tooltip placement="top" title="Crear colaborador">
        <Button
          className="blueButton createCollaboratorButton"
          size="default"
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            woopraTrack("Crear colaborador")
            this.props.history.push("/organization/collaborators/create")
          }}
        />
      </Tooltip>
    )
  }
  
  importCollaborators = () => {
    return (
      <Menu>
        <Menu.Item key="0">
          <Link
            to="/organization/collaborators/import?screen=collaborators"
            onClick={() => woopraTrack("Importar colaboradores")}>
            Colaboradores
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <Link to="/organization/collaborators/import?screen=teams">
            Líderes
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/organization/collaborators/import?screen=ceased">
            Cesados
          </Link>
        </Menu.Item>
      </Menu>
    )
  }

  renderButtonImportEmployee = () => {
    const countEmployees = this.props.collaborators.length
    const freemium = window.freemium()
    if (freemium && freemium.maxEmployees <= countEmployees) {
      return (
        <Popover
          content={
            <div style={{ maxWidth: 220 }}>
              <p>
                La cantidad de colaboradores ha alcanzado el máximo disponible.
              </p>
              <span className="color-gray-low" style={{ fontSize: 12 }}>
                Máximo: {freemium.maxEmployees} colaboradores
              </span>
            </div>
          }
          placement="bottomLeft">
          <Button
            className="blueButton"
            disabled
            size="default"
            icon={<UploadOutlined />}
          />
        </Popover>
      )
    }
    return (
      <Tooltip placement="top" title="Importar">
        <Dropdown overlay={this.importCollaborators()} trigger={["click"]}>
          <Button
            className="whiteButton"
            size="default"
            icon={<UploadOutlined />}
          />
        </Dropdown>
      </Tooltip>
    )
  }

  renderEmptyCollaborators = () => {

    if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
      return this.renderVismaPeopleEmptyState()
    }
    
    return (
      <div>
        <Helmet>
          <title>Organización - Colaboradores</title>
          <meta name="description" content="Description of Collaborators" />
        </Helmet>
        <ImportScreen
          image={collaboratorsSvg}
          title="Carga colaboradores"
          description={`
              Carga la información de los <span>colaboradores</span> que se encuentran dentro de tu organización. Estos
              <br />
              podrán convertirse en usuarios desde la sección Panel de Control - Gestión de Usuarios.
            `}
          secondPoint="Llena los campos con la información de tus colaboradores."
          thirdPoint="Importa el Excel con la información de tus colaboradores.">
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={this.props.isDownloading}
            onClick={() => this.props.getTemplateCollaborators(true)}
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={this.props.isUploading}
            label="Importar colaboradores"
            style={{ marginLeft: "2rem" }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            id="import"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </ImportScreen>
      </div>
    )
  }

  renderButtonActions = () => {
    
    if(this.props.hasCollaborators) {
      if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
        return (
          <div className="vismaPeopleActionButtons">
            <Popover content={<>Exportar colaboradores</>}  placement="bottom">
              <Button style={{ color: '#2694FC' }} icon={<DownloadOutlined />} disabled={this.props.isDownloading} loading={this.props.isDownloading} onClick={() => {
                woopraTrack("Exportar colaboradores")
                this.props.getTemplateCollaborators(false)
              }}>
                Exportar
              </Button>
            </Popover>
            <Popover content={<>Asigna divisiones de forma masiva<br /> a tus colaboradores.</>}  placement="bottom">
              <Button
                type="primary"
                className="assign-divisions-button"
                onClick={() => {
                  this.props.history.push("/organization/collaborators/import?screen=divisions-assignment")
                }}
              >
                Asignar divisiones
              </Button>
            </Popover>
          </div>
        )
      }

      if(!LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
        return (
          <div className="buttonsDivisions">
            <Button
              type="primary"
              className="removeTableButton"
              style={{
                display: this.state.buttonDeleteCollaborators
                  ? "flex"
                  : "none",
              }}
              onClick={() =>
                this.toggleModal("modalDeleteCollaborators", true)
              }>
              <img src={deleteSvg} />
              Eliminar
            </Button>
  
            {this.renderButtonAddEmployee()}
  
            {this.renderButtonImportEmployee()}
  
            <Tooltip
              placement="topRight"
              title="Exportar colaboradores">
              <Button
                className="whiteButton"
                size="default"
                icon={<DownloadOutlined />}
                onClick={() => {
                  woopraTrack("Exportar colaboradores")
                  this.props.getTemplateCollaborators(false)
                }}
              />
            </Tooltip>
          </div>
        )
      }
    }
  }

  searchCollaboratorsDebounce = debounce(this.searchCollaborators, 500)

  render() {
    const { hasDivisions, hasCollaborators, collaborators } = this.props
    const {isFirstTime} = this.state
    if (
      (
        typeof hasDivisions === "undefined" ||
        typeof hasCollaborators === "undefined"
      )
    ) {
      
      return <Loader />
    }

    if (!hasDivisions ) {
      return this.renderEmptyDivisions()
    }

    if (!hasCollaborators ) {
      return this.renderEmptyCollaborators()
    }

    if (!Array.isArray(collaborators.data ) ) {
      
      return <Loader />
    }
    
    return (
      <Fragment>
        <div className="collaborators-header">
          <div className="collaborators-header-left">
            {!LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
              <RadioGroup
                className="collaborators-header-buttons"
                defaultValue="list">
                <RadioButton value="list">Listado</RadioButton>
              </RadioGroup>
            )}
            {LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
              this.props.isLoadingVismaPeopleStatus ? <></> : 
              <>
                <div className="collaborators-header-visma-people-update-notifications">
                  <p><b>Última sincronización</b> de colaboradores: {this.props.vismaPeopleStatus.start_sync_date} a las {this.props.vismaPeopleStatus.start_sync_hour}</p>
                  <p><b>Próxima sincronización</b> de colaboradores: {this.props.vismaPeopleStatus.next_synchronization_date} a las {this.props.vismaPeopleStatus.next_synchronization_hour}</p>
                </div>
              </>
            )}
          </div>
          <div className="collaborators-header-right">
            <FiltersContainer
              removeFilter={this.removeFilter}
              filters={this.state.tagFilters}
            />
            {this.renderFilterColumns()}
            {this.renderFilterSearch()}
            {this.renderButtonActions()}
          </div>
        </div>
        {LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && (
          <div className="collaborators-visma-people-banner">
            <p className="collaborators-visma-people-banner-wrapper">
              <UserAddOutlined style={{ fontSize: 24 }}/>
              <span className="collaborators-visma-people-banner-text">
                Ingresa a Visma People para <b>crear o realizar cambios sobre tus colaboradores</b>. Estos serán reflejados una vez que la plataforma reprocese estos datos.
              </span>
              <Button onClick={() => {
                window.open("https://people.vismalatam.com", "_blank")
              }}>
                Ir a Visma People
              </Button>
            </p>
          </div>
        )}
        <CollaboratorsTable
          setStateFromCollaborators={this.setStateFrom}
          getCollaboratorsPaginated={this.getCollaboratorsPaginated}
          collaborators={collaborators.data}
          searchCollaboratorPaginated={this.searchCollaboratorPaginated}
          onActiveFiltersChange={this.handleActiveFiltersChange}
          leaders={collaborators.leaders}
          divisions={collaborators.divisions}
          segments={collaborators.segments}
          paginate={collaborators}
          onFiltersChange={this.onFiltersChange}
          {...pick(this.state, [
            "columnsSelected",
            "isLoadingTable",
            "inputSearch",
            "filtersDeleted",
            "filtersDropdown",
          ])}
          {...pick(this.props, [
            "getPotentialLeaders",
            "potentialLeaders",
            "toggleModal",
            "isLoadingCollaboratorsTable",
            "searchCollaborators",
            "getTeam",
            "collaboratorTeam",
            "isLoadingCollaboratorTeam",
            "assignLeader",
            "getTeamPotential",
            "teamPotential",
            "isLoadingTeamPotential",
            "addEmployeesTeamWatcher",
            "removeEmployeesTeamWatcher",
            "removeCollaboratorsWatcher",
            "modalDeleteCollaborators",
            "isLoadingPotentialLeaders",
            "getMeasures",
            "isLoadingMeasures",
            "measuresAffected",
            "hasSegments",
            "getCollaboratorsPaginated"
          ])}
        />
      </Fragment>
    )
  
  }
}

Collaborators.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
  collaborators: makeSelectGetCollaborators(),
  isLoadingCollaboratorsTable: makeSelectIsLoadingCollaboratorsTable(),
  hasDivisions: makeSelectHasDivisions(),
  hasCollaborators: makeSelectHasCollaborators(),
  hasSegments: makeSelectHasSegments(),
  collaboratorTeam: makeSelectCollaboratorTeam(),
  isLoadingCollaboratorTeam: makeSelectIsLoadingCollaboratorTeam(),
  potentialLeaders: makeSelectPotentialLeaders(),
  teamPotential: makeSelectTeamPotential(),
  isLoadingTeamPotential: makeSelectIsLoadingTeamPotential(),
  isLoadingPotentialLeaders: makeSelectIsLoadingPotentialLeaders(),
  isLoadingMeasures: makeSelectIsLoadingMeasures(),
  measuresAffected: makeSelectMeasuresAffected(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplateCollaborators: (params) =>
      dispatch(getTemplateCollaboratorsWatcher(params)),
    uploadTemplateCollaborators: (params) =>
      dispatch(uploadTemplateCollaboratorsWatcher(params)),
    getCollaboratorsWatcher: (params) => dispatch(getCollaboratorsWatcher(params)),
    searchCollaboratorsWatcher: (params) =>
      dispatch(searchCollaboratorsWatcher(params)),
    hasDivisionsWatcher: () => dispatch(hasDivisionsWatcher()),
    hasCollaboratorsWatcher: () => dispatch(hasCollaboratorsWatcher()),
    getTeam: (params) => dispatch(getTeamWatcher(params)),
    getPotentialLeaders: (params) =>
      dispatch(getPotentialLeadersWatcher(params)),
    assignLeader: (params) => dispatch(assignLeaderWatcher(params)),
    getTeamPotential: (params) => dispatch(getTeamPotentialWatcher(params)),
    addEmployeesTeamWatcher: (params) =>
      dispatch(addEmployeesTeamWatcher(params)),
    removeEmployeesTeamWatcher: (params) =>
      dispatch(removeEmployeesTeamWatcher(params)),
    removeCollaboratorsWatcher: (params) =>
      dispatch(removeCollaboratorsWatcher(params)),
    getMeasures: (params) => dispatch(getMeasuresWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "collaborators", reducer })
const withSaga = injectSaga({ key: "collaborators", saga })

export default compose(withReducer, withSaga, withConnect, withRouter)(Collaborators)
